import './maxHeight.css'

import axios from 'axios'
import classnames from 'classnames'
import { debounce, first as lodashFirst, get, noop, slice } from 'lodash'
import * as React from 'react'
import Autosuggest from 'react-autosuggest'
import styled from 'styled-components'
const Wrapper = styled.div``

type TSuggestionRenderer = {
  city?: string
  zip?: string
  country?: string
  query?: string
}
const SuggestionRenderer = (props: TSuggestionRenderer): React.ReactElement => {
  const { city, zip, country, query } = props
  return (
    <div style={{ cursor: 'pointer', margin: '' }}>
      <div>
        <strong>{city}</strong>
      </div>
      <div>
        {country}-{zip}
      </div>
    </div>
  )
}

type TZipInput = {
  isInvalid?: boolean
  country?: string
  onChangeCity?: (val: string) => void
  onChange?: (val: string) => void
  readOnly?: boolean
  customZipRenderKey?: string
  className?: string
  value?: string
  selectOnFocus?: boolean
}

type TCity = {
  city?: string
  zip?: string
}

const ZipInput = (props: TZipInput): React.ReactElement => {
  const {
    isInvalid,
    country = 'de',
    onChangeCity = noop,
    readOnly,
    customZipRenderKey,
  } = props

  const [suggestions, setSuggestions] = React.useState([])
  const [inputRef, setInputRef] = React.useState()

  const onSuggestionHighlighted = (value): void => {
    const city = get(value, 'suggestion.city')
    if (city) {
      onChangeCity(city)
    }
  }

  const onSuggestionSelected = (value): void => {
    const city = get(value, 'suggestion.city')
    if (city) {
      onChangeCity(city)
    }
  }

  const onChange = (e, { newValue, method }): void => {
    // console.log("onChange", { newValue, method })
    if (props.onChange) {
      if (method === 'type') {
        props.onChange(newValue)
      } else {
        props.onChange(String(newValue.zip || newValue))
      }
    }

    const city = get(newValue, 'city')
    if (city) {
      onChangeCity(city)
    }
  }

  const request = async (zip, country): Promise<void> => {
    // console.log("request", { zip, country })
    try {
      const { data } = await axios({
        method: 'post',
        url: `/shared/api/fetch/city`,
        data: {
          country,
          zip,
        },
        withCredentials: true,
        validateStatus: (status) => status === 200,
        headers: { 'Accept-Language': i18n?.language ?? 'de' },
      })
      setSuggestions(slice(data, 0, 100))
      if (data.length === 1) {
        const first = lodashFirst(data) as TCity
        onChangeCity(first.city)
      }
    } catch (error) {
      setSuggestions([])
      console.error('Fetching cities failed', error)
    }
  }

  const debouncedRequest = debounce(request, 100)

  const onFetch = ({ value }): void => {
    // console.log("onFetch", value)
    if (value.length < 3) {
      setSuggestions([])
      return
    }
    debouncedRequest(value, country)
  }

  const inputProps = {
    ...props,
    onChange,
    value: props.value as string,
    key: customZipRenderKey,
    className: classnames(
      'form-control',
      {
        'is-invalid': isInvalid,
        readOnly: readOnly,
      },
      props.className || '',
    ),
  }

  // return (
  //   <Wrapper>
  //     <TypeAhead
  //       value={props.value}
  //       onChange={props.onChange}
  //     />
  //   </Wrapper>
  // )

  // setInputRef

  return (
    <Wrapper>
      <Autosuggest
        inputProps={inputProps}
        suggestions={suggestions}
        onSuggestionsFetchRequested={onFetch}
        onSuggestionsClearRequested={noop}
        // onSuggestionHighlighted={onSuggestionHighlighted}
        onSuggestionSelected={onSuggestionSelected}
        getSuggestionValue={(suggestion) => suggestion}
        renderSuggestion={(suggestion, matcher) => (
          <SuggestionRenderer
            {...(suggestion ? suggestion : {})}
            {...matcher}
          />
        )}
        // highlightFirstSuggestion
        // renderInputComponent={inputProps => (
        //   <Input {...inputProps} innerRef={inputProps.ref} />
        // )}
        // TODO: react-autowhatever already renders input?!
        theme={{
          container: 'autosuggest',
          input: 'form-control',
          suggestionsContainer: 'dropdown',
          suggestionsList: `dropdown-menu ${
            suggestions.length ? 'show' : ''
          } dropdown-menu-full-width dropdown-menu-more-shadow maxHeightZipInputDropdown`,
          suggestionFocused: 'active',
          suggestion: 'dropdown-item',
          suggestionHighlighted: 'dropdown-item hovered',
        }}
      />
    </Wrapper>
  )
}

export default ZipInput
